<form [formGroup]="form" (ngSubmit)="submitAction()">
    <div class="modal-header">
        <h4 class="modal-title">{{ title }}</h4>
        <button class="close" type="button" aria-label="Close" (click)="activeModal.close(null)">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="col">
                <h6>
                    {{ message }}
                </h6>
                <hr />
            </div>
        </div>

        @if (showDate) {
            <div class="row">
                <div class="col">
                    <form-datetime
                        formControlName="date"
                        [labelText]="dateLabel ? dateLabel : ('Date' | translate)"></form-datetime>
                </div>
            </div>
        }

        @if (showRemark) {
            <div class="row">
                <div class="col">
                    <form-textbox
                        formControlName="remark"
                        [labelText]="remarkLabel ? remarkLabel : ('Remark' | translate)"></form-textbox>
                </div>
            </div>
        }
    </div>

    <div class="modal-footer">
        <button class="btn btn-sm btn-primary mr-2" type="submit" [disabled]="!form.valid || !form.dirty">
            <fa-icon [icon]="action === 'Cancel' ? ['fas', 'ban'] : ['fas', 'check']"></fa-icon>
            &nbsp;&nbsp;{{ action | translate }}
        </button>
        <button class="btn btn-sm btn-secondary" type="button" (click)="activeModal.close(null)">
            <fa-icon [icon]="['fas', 'times']"></fa-icon>
            &nbsp;&nbsp;{{ 'Cancel' | translate }}
        </button>
    </div>
</form>
